/* ============================================================
   DATA MITRA ASURANSI

   Letakkan di: app/layanan/asuransi/asuransi.js

   Alamat halamannya /layanan/asuransi - sudah ditunjuk menu Header,
   dan sebelum berkas ini ada, menu itu jatuh ke halaman 404.

   Disalin dari daftar Mitra Asuransi di situs lama rsjmc.id.

   ============================================================
   ⚠️⚠️ TIGA HAL YANG PERLU DIPUTUSKAN BAGIAN KEUANGAN /
   PENJAMINAN SEBELUM HALAMAN INI TAYANG

   Ketiganya bukan soal tampilan. Halaman ini memberi tahu orang
   apakah biaya berobatnya ditanggung atau tidak, dan itu keputusan
   yang mereka ambil SEBELUM datang.

   ------------------------------------------------------------
   1. EMPAT ENTRI BERTANDA "(NON LANGGANAN)" TIDAK DITAMPILKAN

       PT. PEMBANGUNAN JAYA ANCOL
       PT. TRAKINDO
       PT. AJINOMOTO
       PT. LASKAR SEMESTA

   Tandanya berbunyi "non langganan" - artinya justru BUKAN mitra.
   Menampilkannya di halaman berjudul "Mitra Asuransi" berarti
   memberi tahu pasien bahwa biayanya ditanggung, padahal tidak.

   Keempatnya TETAP ADA di larik di bawah dengan `langganan: false`,
   tapi tidak dirender. Datanya tidak dibuang supaya tidak hilang
   dari catatan, dan supaya gampang dikembalikan kalau ternyata
   maksud tandanya berbeda.

   → Kalau "non langganan" ternyata berarti sesuatu yang lain
     (misalnya kerja sama tanpa kontrak tahunan tapi tetap
     dilayani), ubah `TAMPILKAN_NON_LANGGANAN` di bawah jadi true.

   ------------------------------------------------------------
   2. NOMOR 78 HILANG DARI SUMBERNYA

   Penomoran di situs lama meloncat dari 77 (GENERALI) langsung ke
   79 (GREAT EASTERN). Jadi daftar ini berisi 121 entri, bukan 122.

   Entah nomor 78 memang dihapus, atau ada satu mitra yang
   terlewat saat daftarnya disalin. → Perlu dicek ke sumber
   aslinya.

   ------------------------------------------------------------
   3. KATA "Total" DI UJUNG 102 NAMA

   102 dari 121 entri berakhiran " Total" - "ACA Total", "AIA
   Total", "PRUDENTIAL Total". Itu hampir pasti label dari sistem
   penjaminan (jenis pertanggungan), bukan bagian dari nama
   perusahaannya.

   Di halaman untuk pasien, kata itu membingungkan: orang mencari
   "Prudential", bukan "PRUDENTIAL Total".

   Jadi kata itu DIBUANG SAAT DITAMPILKAN, bukan dihapus dari data.
   Aslinya tetap tersimpan utuh di bawah, dan pencarian tetap
   menemukan keduanya.

   → Kalau "Total" ternyata bermakna bagi pasien - misalnya
     membedakan pertanggungan penuh dari sebagian - ubah
     `RAPIKAN_NAMA` jadi false, karena artinya kata itu memang
     harus terbaca.

   ============================================================
   CATATAN LAIN

   56 dari 121 entri berawalan "ADMEDIKA". AdMedika adalah pihak
   ketiga pengelola penjaminan, bukan perusahaan asuransinya
   sendiri. Halaman ini menampilkannya apa adanya karena begitulah
   nama yang tertera di kartu peserta - orang mencocokkan dengan
   kartunya, bukan dengan nama perusahaan induknya.

   ⚠️ Daftar mitra berubah. Kontrak berakhir, mitra baru masuk.
   Halaman ini memuat tanggal pembaruan di TERAKHIR_DIPERBARUI di
   bawah - PERBARUI TANGGALNYA setiap kali daftarnya disunting.
   Daftar tanpa tanggal membuat orang menganggapnya berlaku
   selamanya.
   ============================================================ */

/* Ubah jadi true kalau keempat entri "(NON LANGGANAN)" ternyata
   memang dilayani. Baca alasannya di poin 1 di atas. */
export const TAMPILKAN_NON_LANGGANAN = false;

/* Ubah jadi false kalau kata "Total" memang harus terbaca pasien.
   Baca alasannya di poin 3 di atas. */
export const RAPIKAN_NAMA = true;

/* ============================================================
   LOGO MITRA

   Halaman menampilkan logo dalam grid, dan JATUH KEMBALI ke nama
   dalam kotak kalau berkas logonya belum ada. Jadi halamannya utuh
   sejak hari pertama, dan logo bisa dipasang sedikit demi sedikit
   tanpa menyentuh kode lagi.

   ------------------------------------------------------------
   DI MANA BERKASNYA DITARUH

       public/images/asuransi/

   Nama berkas dibentuk otomatis dari nama yang TAMPIL (setelah
   " Total" dibuang), huruf kecil semua, spasi jadi tanda hubung:

       "BPJS KETENAGAKERJAAN"  ->  bpjs-ketenagakerjaan.png
       "PRUDENTIAL Total"      ->  prudential.png
       "PT. BANK BTN"          ->  pt-bank-btn.png

   Buka halamannya untuk melihat nama berkas yang sedang ditunggu -
   tiap kotak tanpa logo menuliskannya sendiri. Tidak perlu membuka
   berkas ini untuk mencocokkan.

   KALAU NAMA BERKASNYA TERLANJUR BERBEDA, tulis path-nya langsung
   di entri yang bersangkutan; nilai itu menang atas nama otomatis:

       { nama: "PRUDENTIAL Total", logo: "/images/asuransi/pru.svg" },

   ------------------------------------------------------------
   BENTUK BERKAS YANG DISARANKAN

   PNG berlatar TRANSPARAN, tinggi sekitar 200px. Kotaknya berlatar
   putih, jadi logo berlatar putih pun terlihat rapi - tapi logo
   berlatar warna akan tampak seperti tempelan. SVG lebih baik lagi
   kalau mitranya menyediakan.

   ------------------------------------------------------------
   ⚠️ SEBELUM MEMASANG LOGO, BACA INI

   Logo asuransi adalah merek dagang terdaftar. Sebagian mitra
   mensyaratkan izin tertulis sebelum logonya dipakai pihak lain,
   dan sebagian mengatur ukuran minimum serta larangan mengubah
   warna. Ketentuannya biasanya ada di perjanjian kerja sama.
   Tanyakan ke bagian legal atau penjaminan RS sebelum 117 logo
   dipasang - bukan sesudah.

   ⚠️ 56 DARI DAFTAR INI BERAWALAN "ADMEDIKA". AdMedika adalah
   pengelola penjaminan, bukan 56 perusahaan berbeda. Kalau
   semuanya diberi logo AdMedika yang sama, grid-nya akan berisi 56
   kotak kembar dan justru terlihat salah. Pilihan yang lebih
   masuk akal: beri logo hanya pada nama merek yang berdiri
   sendiri, dan biarkan entri ADMEDIKA tampil sebagai teks - itu
   juga yang tertera di kartu peserta.
   ============================================================ */

/* Ubah jadi false kalau Anda ingin HANYA entri dengan field `logo`
   yang mencoba memuat gambar. Selama true, tiap entri mencoba nama
   berkas otomatis - kotak yang berkasnya belum ada tetap tampil
   sebagai teks, tapi browser mencatat satu permintaan gagal per
   berkas di tab Network. Tidak merusak apa pun, hanya berisik saat
   Anda sedang memeriksa jaringan. */
export const LOGO_OTOMATIS = true;

export const LOGO_DIR = "/images/asuransi/";

/* Dipakai halaman untuk menebak nama berkas, dan untuk menuliskan
   nama itu di kotak yang logonya belum ada. */
export function logoDari(mitra) {
  if (mitra && typeof mitra.logo === "string" && mitra.logo) return mitra.logo;
  if (!LOGO_OTOMATIS) return null;

  const slug = namaTampil(mitra?.nama || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return slug ? `${LOGO_DIR}${slug}.png` : null;
}

/* ⚠️ PERBARUI SETIAP KALI DAFTAR DI BAWAH DISUNTING.
   Ditampilkan di halaman sebagai "Diperbarui ...". Kosongkan
   (null) kalau tanggalnya tidak diketahui - lebih baik tanpa
   tanggal daripada tanggal yang salah. */
export const TERAKHIR_DIPERBARUI = null;

/* ============================================================
   DAFTAR

   Urutannya persis seperti di sumber. Jangan diurutkan ulang di
   sini - halaman yang mengelompokkannya sendiri per huruf, jadi
   urutan di berkas ini tidak memengaruhi tampilan, dan menjaganya
   tetap sama memudahkan pembandingan dengan sumber aslinya.

   `langganan: false` hanya ditulis pada yang bukan mitra. Sisanya
   dianggap true.
   ============================================================ */
export const MITRA = [
  { nama: "AA INTERNATIONAL" },
  { nama: "ABDA Total" },
  { nama: "ACA Total" },
  { nama: "ADMEDIKA A CARE" },
  { nama: "ADMEDIKA ACA PRM Total" },
  { nama: "ADMEDIKA ACPHLT Total" },
  { nama: "ADMEDIKA ALAMI Total" },
  { nama: "ADMEDIKA ANGKASA PURA Total" },
  { nama: "ADMEDIKA ASKRIDA Total" },
  { nama: "ADMEDIKA BCA LIFE Total" },
  { nama: "ADMEDIKA BOSOWA Total" },
  { nama: "ADMEDIKA BPBERAU Total" },
  { nama: "ADMEDIKA BPKH Total" },
  { nama: "ADMEDIKA BRI LIFE Total" },
  { nama: "ADMEDIKA BUMIPUTRA" },
  { nama: "ADMEDIKA CHUBB Total" },
  { nama: "ADMEDIKA CIGNA Total" },
  { nama: "ADMEDIKA CIGNA SANGHAI Total" },
  { nama: "ADMEDIKA CHINA LIFE" },
  { nama: "ADMEDIKA CMNP Total" },
  { nama: "ADMEDIKA GANESHA Total" },
  { nama: "ADMEDIKA HANWA LIFE Total" },
  { nama: "ADMEDIKA HARTA Total" },
  { nama: "ADMEDIKA IFORTE Total" },
  { nama: "ADMEDIKA ILGKSK Total" },
  { nama: "ADMEDIKA INPEX" },
  { nama: "ADMEDIKA INTRA ASIA Total" },
  { nama: "ADMEDIKA JASAMARGA Total" },
  { nama: "ADMEDIKA JALIN" },
  { nama: "ADMEDIKA JMA SYARIAH Total" },
  { nama: "ADMEDIKA KARYAWAN Total" },
  { nama: "ADMEDIKA KCI Total" },
  { nama: "ADMEDIKA KCIC Total" },
  { nama: "ADMEDIKA KSKII Total" },
  { nama: "ADMEDIKA LPS Total" },
  { nama: "ADMEDIKA MANDIRI AXA GENERAL INSURANCE Total" },
  { nama: "ADMEDIKA MAYBANK Total" },
  { nama: "ADMEDIKA MITRA KARSA UTAMA" },
  { nama: "ADMEDIKA METRO TV Total" },
  { nama: "ADMEDIKA MRT Total" },
  { nama: "ADMEDIKA MYBANK Total" },
  { nama: "ADMEDIKA PATRASK" },
  { nama: "ADMEDIKA PCET Total" },
  { nama: "ADMEDIKA PCVICGR Total" },
  { nama: "ADMEDIKA PERTAL Total" },
  { nama: "ADMEDIKA PETRO CHINA Total" },
  { nama: "ADMEDIKA PETROGAS Total" },
  { nama: "ADMEDIKA PGE Total" },
  { nama: "ADMEDIKA PGN COM Total" },
  { nama: "ADMEDIKA PGN GAS Total" },
  { nama: "ADMEDIKA PGN NET" },
  { nama: "ADMEDIKA PGN SOL" },
  { nama: "ADMEDIKA SEQUIS LIFE Total" },
  { nama: "ADMEDIKA SOMPO Total" },
  { nama: "ADMEDIKA SUN LIFE" },
  { nama: "ADMEDIKA TCID Total" },
  { nama: "ADMEDIKA TOKIO MARINE Total" },
  { nama: "ADMEDIKA TPI Total" },
  { nama: "ADMEDIKA YAYASAN BINUS Total" },
  { nama: "AIA Total" },
  { nama: "ALLIANZ Total" },
  { nama: "ALODOKTER (PLATFORM) Total" },
  { nama: "APLIKANUSA LINTASARTA Total" },
  { nama: "ASO TIRTA Total" },
  { nama: "ASTRA BUANA/GARDA Total" },
  { nama: "AVRIST Total" },
  { nama: "AXA MANDIRI FINANCIAL SERVICE Total" },
  { nama: "BINTANG Total" },
  { nama: "BNI LIFE INSURANCE Total" },
  { nama: "BPJS KETENAGAKERJAAN Total" },
  { nama: "CAR Total" },
  { nama: "CHUBB Total" },
  { nama: "CITAS OTIS Total" },
  { nama: "EQUITY Total" },
  { nama: "FULLERTON, PT Total" },
  { nama: "FWD INSURANCE Total" },
  { nama: "GENERALI Total" },
  { nama: "GREAT EASTERN Total" },
  { nama: "HALODOC Total" },
  { nama: "HALODOC (PLATFORM) Total" },
  { nama: "HANWA HALODOC Total" },
  { nama: "JASINDO Total" },
  { nama: "LIPPO GENERAL Total" },
  { nama: "MANDIRI AXA GENERAL INSURANCE - FULLERTON Total" },
  { nama: "MANDIRI INHEALTH Total" },
  { nama: "MANULIFE Total" },
  { nama: "MEDIKA PLAZA Total" },
  { nama: "MEGA INSURANCE - FULLERTON Total" },
  { nama: "MNC Total" },
  { nama: "MULTI ARTHA GUNA TBK Total" },
  { nama: "MULTI TEKNINDO INDONESIA Total" },
  { nama: "PACIFIC CROSS Total" },
  { nama: "PACIFIC CROSS ETIQA Total" },
  { nama: "PAN PACIFIC" },
  { nama: "PERTALIFE Total" },
  { nama: "PLN INSURANCE Total" },
  { nama: "PRUDENTIAL Total" },
  { nama: "PT SAPTA INDRA SEJATI Total" },
  { nama: "PT. ASTRA GRAPHIA Total" },
  { nama: "PT. ASURANSI JIWA ASTRA Total" },
  { nama: "PT. BANK BTN Total" },
  { nama: "PT. JASARAHARJA Total" },
  { nama: "PT. PEMBANGUNAN JAYA ANCOL (NON LANGGANAN)", langganan: false },
  { nama: "PT. PINTAR DATA GROUP Total" },
  { nama: "PT. UNISON Total" },
  { nama: "PT. YAMAHA INDONESIA Total" },
  { nama: "PT. TRAKINDO (NON LANGGANAN)", langganan: false },
  { nama: "PT. MONIER" },
  { nama: "PT. ENECAL INDONESIA" },
  { nama: "PT. AJINOMOTO (NON LANGGANAN)", langganan: false },
  { nama: "PT. LASKAR SEMESTA (NON LANGGANAN)", langganan: false },
  { nama: "PT. SAMUDERA" },
  { nama: "RAMAYANA Total" },
  { nama: "RELIANCE Total" },
  { nama: "SINARMAS Total" },
  { nama: "SINARMAS MSIG Total" },
  { nama: "TAKAFUL Total" },
  { nama: "TELKOMEDIKA Total" },
  { nama: "TOKIO MARINE HALODOC Total" },
  { nama: "YKP OJK Total" },
  { nama: "ZURICH ASURANSI INDONESIA TBK Total" },
];

/* ============================================================
   NAMA UNTUK DITAMPILKAN

   Membuang label sistem dari ujung nama. Lihat poin 3 di kepala
   berkas.

   Yang dibuang hanya " Total" DI UJUNG dan " (NON LANGGANAN)" -
   bukan di tengah nama. "MULTI ARTHA GUNA TBK Total" jadi "MULTI
   ARTHA GUNA TBK", sementara "PT. PINTAR DATA GROUP Total" jadi
   "PT. PINTAR DATA GROUP". Tidak ada nama yang memuat kata "Total"
   di tengahnya, jadi pemotongan di ujung aman - tapi periksa lagi
   kalau ada mitra baru ditambahkan.
   ============================================================ */
export function namaTampil(nama) {
  if (!RAPIKAN_NAMA) return nama;
  return String(nama)
    .replace(/\s*\(NON LANGGANAN\)\s*$/i, "")
    .replace(/\s+Total\s*$/i, "")
    .trim();
}

/* Yang benar-benar dirender. Disaring di satu tempat supaya halaman
   dan penghitung jumlahnya tidak pernah berbeda isi. */
export function mitraTampil() {
  return MITRA.filter((m) => TAMPILKAN_NON_LANGGANAN || m.langganan !== false);
}

/* ============================================================
   KONTAK

   Nomor Umum/Asuransi diambil dari poster jadwal poliklinik RS JMC
   (tertera di kaki tiap poster), nomor hunting dari data halaman
   layanan lain. Keduanya disalin, bukan dikarang.

   Kenapa ada di halaman ini: daftar mitra TIDAK menjawab
   pertanyaan yang sebenarnya - apakah polis SAYA berlaku untuk
   tindakan yang SAYA butuhkan. Itu bergantung pada jenis polis,
   plafon, dan rujukan. Jadi halaman ini harus berakhir dengan
   nomor yang bisa menjawabnya, bukan dengan daftar saja.
   ============================================================ */
export const KONTAK = [
  {
    label: { id: "Umum / Asuransi", en: "Private / Insurance" },
    tampil: "0811-901-874",
    tel: "+62811901874",
    wa: "62811901874",
    utama: true,
  },
  {
    label: { id: "Hunting", en: "Main line" },
    tampil: "(021) 798 0888",
    tel: "+62217980888",
    utama: false,
  },
];

export const PESAN_WA = {
  id: "Halo RS Jakarta Medical Center,\n\nSaya ingin menanyakan apakah asuransi saya dapat digunakan di RS JMC.\n\nNama asuransi:\nNomor polis/kartu:\nJenis layanan yang dibutuhkan:\n\nMohon bantuannya. Terima kasih.",
  en: "Hello RS Jakarta Medical Center,\n\nI would like to check whether my insurance is accepted at RS JMC.\n\nInsurer:\nPolicy/card number:\nService needed:\n\nThank you for your help.",
};
